webpackJsonp([144699972088326],{

/***/ 1178:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0004_tenderfoot.jpg","type":"Unit","subtype":"Virtuoso","cost":1,"ATK":1,"HP":2,"rules_text_1":null,"rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Tenderfoot","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"\"I practice every day. I'm rapidly improving. At this rate, I'll be a Blademaster in no time. Sometimes I have bad days though. Like last week my dog ran away.\"","color":"Neutral","spec":null,"bottom":"Tech 0","rulings":[],"keywords":[],"slug":"tenderfoot"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"tenderfoot","keywords":[],"imageRegex":"/tenderfoot.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-tenderfoot-9d7cec4e057f744a6123.js